import { X, Music } from 'lucide-react';
import type { RouletteRound } from '../../services/roulette';

interface RouletteSpotlightBannerProps {
  round: RouletteRound;
  attendeeId: string;
  onDismiss: () => void;
}

export default function RouletteSpotlightBanner({ round, attendeeId, onDismiss }: RouletteSpotlightBannerProps) {
  const isWinner = attendeeId === round.winnerId;
  const wasEntrant = !isWinner && round.entrantIds.includes(attendeeId);

  return (
    <div
      role="status"
      className="animate-slide-down relative mx-2 mb-3 rounded-xl bg-gradient-to-r from-amber-500 to-pink-500 p-[2px] shadow-lg z-40"
    >
      <div className="rounded-[10px] bg-white dark:bg-gray-900 p-4 pr-10">
        <button
          onClick={onDismiss}
          className="absolute top-3 right-3 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4 text-gray-400" />
        </button>

        <p className="text-xs font-semibold uppercase tracking-wide text-amber-600 dark:text-amber-400">🎰 Request Roulette</p>
        <div className="mt-2 flex items-center gap-3">
          {round.albumArtUrl ? (
            <img src={round.albumArtUrl} alt="" className="w-12 h-12 rounded-lg object-cover flex-shrink-0" />
          ) : (
            <div className="w-12 h-12 rounded-lg bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center flex-shrink-0">
              <Music className="w-5 h-5 text-amber-500" />
            </div>
          )}
          <div className="min-w-0">
            <p className="font-semibold text-gray-900 dark:text-white text-sm truncate">
              "{round.songTitle}" — {round.songArtist}
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              {round.entrantCount} in the draw · Winner: {round.winnerNickname}
            </p>
          </div>
        </div>
        {isWinner && (
          <p className="mt-2 text-sm font-medium text-emerald-600 dark:text-emerald-400">That's you! Check your prize.</p>
        )}
        {wasEntrant && (
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">You were in the draw — keep voting for songs you love.</p>
        )}
        {!isWinner && !wasEntrant && (
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">You weren't in the draw this time — vote for songs you love to get in the next one.</p>
        )}
      </div>
    </div>
  );
}
